import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { ERoutes } from '@enums/routes.enum';
import type { RootState } from '@store/store';

const ProtectedRoute = () => {
	const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
	const location = useLocation();

	if (!isAuthenticated) {
		return <Navigate to={ERoutes.search} state={{ from: location }} replace />;
	}

	return <Outlet />;
};

export default ProtectedRoute;
